import { useMemo } from 'react';
import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { useAuthStore } from '@/modules/user';
import useEmployeeViewDataQuery, { QUERY_KEY } from '@/modules/user/queries/useEmployeeViewData.query';

import { PersonalInfoPayload } from '../PersonalInfoForm/stores/usePersonalInfo.store';

const getPhoneNumber = (number?: string) => {
  if (number) {
    return {
      phone: {
        number: number,
      },
    };
  }

  return {};
};

type SavePersonalPayload = Partial<PersonalInfoPayload> & {
  isReject?: boolean;
};

const useSavePersonalInfoQuery = () => {
  const { user } = useAuthStore();
  const query = useQueryClient();
  const employeeId = useMemo(() => `${user?.employee?.id || ''}`, [user]);
  const { rawData, isLoading: isEmployeeLoading } = useEmployeeViewDataQuery(employeeId);
  const { mutateAsync, isLoading } = useMutation(
    (data: SavePersonalPayload) =>
      api.patch(API_URL.UI_EMPLOYEES, {
        ..._.pickBy({
          citizenship_country_id: _.toNumber(data.citizenship || rawData?.citizenship_country_id),
          // ...getPhoneNumber(data.phoneType || rawData?.phone?.phone_type),
        }),
      }),
    {
      onSuccess: async (_, payload) => {
        if (!payload?.isReject) {
          await query.invalidateQueries({
            queryKey: [QUERY_KEY, API_URL.EMPLOYEES_EMPLOYEE_VIEW_BY_EMPLOYEE_ID(employeeId)],
          });
        }
      },
    }
  );

  return {
    handleSave: mutateAsync,
    isLoading: isLoading || isEmployeeLoading,
  };
};
export default useSavePersonalInfoQuery;
